import { Button } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  width: 100%;
  flex-wrap: wrap;
`;

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  padding: 0.8rem;
  width: 100%;
  height: fit-content;
  background: ${({ theme }) => theme.colors.grey[200]};
  border-radius: 0.6rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.grey[300]};
`;

export const StyledButton = styled(Button)`
  border: unset;
  background-color: transparent;
  font-size: large;
  color: ${({ theme }) => theme.colors.black};
`;
